import { createSlice } from "@reduxjs/toolkit";

const verifySlice = createSlice({
    name: "verify",
    initialState: {
        verify: false
    },
    reducers: {
        toggleVerify: (state, action) => {
            state.verify = action.payload;
        },
    }
});

export const { toggleVerify } = verifySlice.actions;
export default verifySlice.reducer;